import {testIdProps} from '@github-ui/test-id-props'
import {ArchiveIcon, ClockIcon} from '@primer/octicons-react'
import {Button} from '@primer/react'
import {clsx} from 'clsx'

import type {IterationConfiguration} from '../../../../api/columns/contracts/iteration'
import iterationStyles from './iteration-row-skeleton.module.css'
import styles from './iterations-header.module.css'
import {NewIterationModalButton, type NewIterationModalButtonProps} from './new-iteration-modal-button'
import type {SelectedTab} from './types'

type IterationHeaderProps = {
  selectedTab: SelectedTab
  setSelectedTab: (tab: SelectedTab) => void
  configuration: IterationConfiguration
  addButtonProps: NewIterationModalButtonProps
  disabled?: boolean
  tabpanelId: string
}

export function IterationsHeader({
  selectedTab,
  setSelectedTab,
  configuration,
  addButtonProps,
  disabled = false,
  tabpanelId,
}: IterationHeaderProps) {
  const activeIterationsCount = configuration.iterations.length
  const completedIterationsCount = configuration.completedIterations.length

  return (
    <div>
      <div className={clsx(iterationStyles.baseIteration, styles.Box)}>
        <div role="tablist" aria-disabled={disabled} style={{display: 'flex'}}>
          <Button
            className={clsx(styles.Button, disabled && styles.disabled, selectedTab === 'active' && styles.selected)}
            key="active"
            role="tab"
            aria-controls={selectedTab === 'active' ? tabpanelId : undefined}
            {...testIdProps('active-iterations')}
            onClick={() => {
              if (!disabled) setSelectedTab('active')
            }}
            aria-label="Active iterations"
            aria-disabled={disabled}
            aria-selected={selectedTab === 'active'}
            disabled={disabled}
          >
            <ClockIcon aria-label="Active iterations" className={styles.Octicon} />
            <span>{activeIterationsCount} Active</span>
          </Button>

          <Button
            className={clsx(styles.Button, disabled && styles.disabled, selectedTab === 'completed' && styles.selected)}
            key="completed"
            role="tab"
            aria-controls={selectedTab === 'completed' ? tabpanelId : undefined}
            {...testIdProps('completed-iterations')}
            onClick={() => {
              if (!disabled) setSelectedTab('completed')
            }}
            aria-label="Completed iterations"
            aria-disabled={disabled}
            aria-selected={selectedTab === 'completed'}
            disabled={disabled}
          >
            <ArchiveIcon aria-label="Completed iterations" className={styles.Octicon} />
            <span>{completedIterationsCount} Completed</span>
          </Button>
        </div>
        {selectedTab === 'active' && (
          <div className={styles.Box_1}>
            <NewIterationModalButton {...addButtonProps} />
          </div>
        )}
      </div>
    </div>
  )
}
